import React from 'react';
import { Button, Modal } from 'tea-component';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import { queryJumpable } from '@gp/utils/common';
import { getProjectDetailsPagePath, goToProjectDetailsPageByPath } from '@gp/utils/project';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';

import type { IBaseProps } from '@home/types/common';
import type { ListItemType } from '../../types';

import './index.scss';

interface IReleasesModalProps extends IBaseProps {
  domain?: 'gameDetail' | 'milestone';
  title: string;
  data: ListItemType[];
  visible: boolean;
  close: () => void;
}

const ReleasesModal: React.FC<IReleasesModalProps> = (props) => {
  const { domain, title, data, visible, close } = props;

  return (
    <Modal className="dbg-releases-modal" size={600} caption={title || '-'} visible={visible} onClose={close}>
      <Modal.Body>
        <div className="dbg-releases-modal-context">
          {data?.map((item, index) => {
            const {
              id: itemId,
              title: itemTitle,
              img: itemImg,
              time: itemTime,
              timeConfirm: itemTimeConfirm,
            } = item || {};

            const itemUrl = getProjectDetailsPagePath({
              id: itemId as any,
              name: itemTitle,
              tab: domain,
            });

            return (
              <div key={index} className="dbg-releases-modal-item">
                <div
                  className="dbg-releases-modal-img"
                  onClick={(e) => {
                    if (!queryJumpable(e)) return;
                    goToProjectDetailsPageByPath(itemUrl);
                  }}
                >
                  <GeneralImageNew width={54} height={54} src={itemImg || ''} />
                </div>
                <LinkJump url={itemUrl}>
                  <div
                    onClick={(e) => {
                      if (!queryJumpable(e)) return;
                      goToProjectDetailsPageByPath(itemUrl);
                    }}
                  >
                    <EllipsisTextBubble
                      key={String(visible)}
                      className="dbg-releases-modal-text"
                      text={itemTitle || '-'}
                      ellipsisLineClamp={2}
                    />
                    <div className="dbg-releases-modal-time">
                      {formatMilestoneDateByStatus(itemTime, itemTimeConfirm) || '-'}
                    </div>
                  </div>
                </LinkJump>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="weak" onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(ReleasesModal);
